import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../services/service.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from "jquery";

@Component({
  selector: 'app-user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.css']
})
export class UserAccessComponent implements OnInit {
  
  public selectedUser = null;
  public userFilter = null;
  public users : any;
  public products = [];
  selectedProduct;

  userFilterConfig = {
    displayKey: 'email', //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: '309px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Filter User', // text to be displayed when no item is selected defaults to Select,
    customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    limitTo: 100, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search Users', // label thats displayed in search input,
    searchOnKey: 'email', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }

  productFilterConfig = {
    displayKey: 'userModule.moduleName', //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: '309px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Filter Product', // text to be displayed when no item is selected defaults to Select,
    customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    limitTo: 100, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search Product', // label thats displayed in search input,
    searchOnKey: 'email', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }

  constructor(private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService) { }

  ngOnInit() {
    this.getUsers();
  }

   /**
   * Getting user list.
   */
  private getUsers() {
    $(".overlay-loading").show();
    let url = 'get-all-users' + '?size=200&page=0&sort-by=billOfLadingId&order-by=asc';
    this.service.getUserList(url).subscribe(data => {
      $(".overlay-loading").hide();
      this.users = data;
    });
  }

  /**
   * user Filter changes...
   * @param user 
   */
  public changeuserFilter(): void {
    
    let user = this.selectedUser;
    if (user) {
      this.userFilter = user ? user.locationID : null;
      this.userFilter += ':' + user.tenant;
    }
    else {
      this.userFilter = null;
    }
    if(this.userFilter){
    }
  }

  public findUserModuleAccess(){
    this.service.fetchUserModulesAccess(this.selectedUser).subscribe(modules => {
      console.log("User Modules", modules);
      this.products = modules;
    })
  }

  public findProductTenants(){

  }

}
